import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { statusTagRootVariant } from './status-tag-variants'

type Props = ComponentPropsWithoutRef<'div'> & {
  /** タグの色 */
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'green'
    | 'yellow'
    | 'red'
    | 'orange-5'
    | 'orange-6'
    | 'orange-7'
    | 'blue-5'
    | 'green-7'
    | 'green-8'
  /** block要素にするかどうか */
  block?: boolean
  size?: 'default' | 'small'
}

/**
 * ステータスなどを表示するためのタグ
 */
export const StatusTag: FC<Props> = ({
  className,
  color = 'primary',
  size = 'default',
  block = false,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={clsx([
        '',
        statusTagRootVariant({ color, block, size }),
        className
      ])}
    >
      {children}
    </div>
  )
}
